export const SUBMISSION_PROCESSING_UNAVAILABLE_CODE = 'submission_processing_unavailable';

export const SUBMISSION_PROCESSING_UNAVAILABLE_COPY =
  'We could not process your work right now. Try submitting the same upload again, or use tutor review if it was already marked.';

export const SUBMISSION_UNREADABLE_COPY =
  'The work could not be read. Try a clearer upload before marking, or use tutor review if already marked.';
